// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"490":"d3104eec63caf29f","972":"362f030d4d42b2cf"}[chunkId] + ".js";
};